"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7790],{

/***/ 17790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hoverable_cards_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/consts.js
var consts = __webpack_require__(49929);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-card/hoverable-card.scss.js




var CARD_MAX_PADDING = 32;
var DEFAULT_TITLE_FONT_SIZE = "24px";
var getResponsiveSizeCalc = function(size, resizeFactor, minimumSize) {
    return "calc(max(100vw / ".concat(vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, " * ").concat(size, " * ").concat(resizeFactor, ", ").concat(minimumSize, "))");
};
var StyledHoverableCards = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "en2yo6d0"
})("position:relative;flex:1;color:", function(props) {
    var _getTheme;
    return (_getTheme = (0,segments_service/* getTheme */.gh)(props.hoveredColor)) === null || _getTheme === void 0 ? void 0 : _getTheme.color;
}, ";background-color:", function(props) {
    return colors/* default */.Z[props.defaultColor];
}, ";border-radius:8px;overflow:hidden;transition:background-color 0.5s ease-in-out,clip-path 0.5s ease-in-out;clip-path:inset(10px 0 10px 0 round 8px);@media (max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px){.card-title{font-size:", function(param) {
    var titleSize = param.titleSize, textResizeConfig = param.textResizeConfig;
    return getResponsiveSizeCalc(titleSize, textResizeConfig === null || textResizeConfig === void 0 ? void 0 : textResizeConfig.resizeFactor, (textResizeConfig === null || textResizeConfig === void 0 ? void 0 : textResizeConfig.minimumFont) || DEFAULT_TITLE_FONT_SIZE);
}, ";line-height:", function(param) {
    var textResizeConfig = param.textResizeConfig, titleLineHeight = param.titleLineHeight;
    return getResponsiveSizeCalc(titleLineHeight, textResizeConfig === null || textResizeConfig === void 0 ? void 0 : textResizeConfig.resizeFactor, "32px");
}, ";}.paragraph-wrapper .paragraph-body{font-size:calc(max(100vw / ", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, " * 16,16px));line-height:calc(max(100vw / ", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, " * 32,24px));}}.card-title{transform:scale(0.8);transform-origin:center left;transition:transform 0.3s ease-in-out;font-weight:600;}.paragraph-body-wrapper{overflow:visible;}.asset-container{position:relative;width:100%;z-index:0;display:flex;.default-asset,.selected-asset{width:100%;display:flex;justify-content:center;align-items:center;transition:opacity 0.5s ease-in-out;img,svg,video,*{width:100%;height:auto;max-width:100%;display:block;}}.selected-asset{position:absolute;top:0;left:0;height:100%;}}.paragraph-container{position:absolute;bottom:0;left:0;z-index:1;display:flex;flex-direction:column;justify-content:flex-end;width:100%;padding:", CARD_MAX_PADDING, "px;@media (max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px){padding:", "calc(max(100vw / ".concat(vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, " * ").concat(CARD_MAX_PADDING, ", 20px))"), ";}}&.selected{background-color:", function(props) {
    return colors/* default */.Z[props.hoveredColor];
}, ";clip-path:inset(0 0 0 0 round 8px);.card-title{transform:scale(1);}.paragraph-body-wrapper{opacity:1;}.selected-asset{opacity:1;}.default-asset{opacity:0;}transition:all 0.5s ease-in-out;}&:not(.selected){background-color:", function(props) {
    return colors/* default */.Z[props.defaultColor];
}, ";clip-path:inset(10px 0 10px 0 round 8px);.asset-container{opacity:0.7;}.selected-asset{opacity:0;}.default-asset{opacity:1;}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-card/hoverable-card.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var REM_TO_PX = 16;
var DEFAULT_PARAGRAPH = {
    topic: {}
};
var HoverableCard = function(_param) {
    var defaultColor = _param.defaultColor, asset = _param.asset, hoveredAsset = _param.hoveredAsset, paragraph = _param.paragraph, hoveredColor = _param.hoveredColor, onHover = _param.onHover, isSelected = _param.isSelected, textResizeConfig = _param.textResizeConfig, _fullParagraphAdvancedConfig = _param.fullParagraphAdvancedConfig, selectedTitleSize = _fullParagraphAdvancedConfig.selectedTitleSize, _titleSize = _fullParagraphAdvancedConfig.titleSize, titleSize = _titleSize === void 0 ? sizes.MD : _titleSize, paragraphConfig = _object_without_properties(_param.fullParagraphAdvancedConfig, [
        "selectedTitleSize",
        "titleSize"
    ]);
    var titleSizeInPx = (0,react.useMemo)(function() {
        return consts/* titleFontSizeNumber */.t_[titleSize] * REM_TO_PX;
    }, [
        titleSize
    ]);
    var titleLineHeight = (0,react.useMemo)(function() {
        var _titleLineHeights_titleSize;
        return (_titleLineHeights_titleSize = consts/* titleLineHeights */.DJ[titleSize]) === null || _titleLineHeights_titleSize === void 0 ? void 0 : _titleLineHeights_titleSize.replace("px", "");
    }, [
        titleSize
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHoverableCards, {
        textResizeConfig: textResizeConfig,
        titleSize: titleSizeInPx,
        defaultColor: defaultColor,
        onMouseEnter: onHover,
        titleLineHeight: titleLineHeight,
        hoveredColor: hoveredColor,
        className: classnames_default()("hoverable-card", {
            selected: isSelected
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "asset-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "default-asset",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, asset))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "selected-asset",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, hoveredAsset))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "paragraph-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread_props(_object_spread({}, DEFAULT_PARAGRAPH, paragraph, paragraphConfig), {
                    titleSize: selectedTitleSize,
                    titleClassName: "card-title"
                }))
            })
        ]
    });
};
/* harmony default export */ var hoverable_card = (HoverableCard);

// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-cards-grid-component.scss.js



var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var StyledHoverableCardsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egv6xxj0"
})("max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px;min-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, ";margin:auto;display:flex;gap:8px;padding:0 ", HEADER_LOGO_HORIZONTAL_PADDING, ";justify-content:center;");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-cards-grid-component.js
function hoverable_cards_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hoverable_cards_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hoverable_cards_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hoverable_cards_grid_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hoverable_cards_grid_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hoverable_cards_grid_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var HoverableCardsGridComponent = function(param) {
    var cards = param.cards, defaultHoveredCard = param.defaultHoveredCard, defaultColor = param.defaultColor, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, textResizeConfig = param.textResizeConfig;
    var ref = (0,react.useState)(defaultHoveredCard - 1 < cards.length ? defaultHoveredCard - 1 : 0), selectedCardIndex = ref[0], setSelectedCardIndex = ref[1];
    var onCardHover = function(index) {
        var _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef, _cardsWithVideoPlayerRef_index_hoveredAsset_video, _cardsWithVideoPlayerRef_index_hoveredAsset;
        setSelectedCardIndex(index);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HOVERABLE_CARD_HOVERED, {
            info1: index
        });
        if ((_cardsWithVideoPlayerRef_index_hoveredAsset = cardsWithVideoPlayerRef[index].hoveredAsset) === null || _cardsWithVideoPlayerRef_index_hoveredAsset === void 0 ? void 0 : (_cardsWithVideoPlayerRef_index_hoveredAsset_video = _cardsWithVideoPlayerRef_index_hoveredAsset.video) === null || _cardsWithVideoPlayerRef_index_hoveredAsset_video === void 0 ? void 0 : (_cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef = _cardsWithVideoPlayerRef_index_hoveredAsset_video.videoPlayerRef) === null || _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef === void 0 ? void 0 : _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef.current) {
            var _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current;
            (_cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current = cardsWithVideoPlayerRef[index].hoveredAsset.video.videoPlayerRef.current) === null || _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current === void 0 ? void 0 : _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current.seekTo(0);
        }
    };
    var cardsWithVideoPlayerRef = cards.map(function(card) {
        var _card_hoveredAsset;
        return hoverable_cards_grid_component_object_spread_props(hoverable_cards_grid_component_object_spread({}, card), {
            hoveredAsset: hoverable_cards_grid_component_object_spread({}, card.hoveredAsset, ((_card_hoveredAsset = card.hoveredAsset) === null || _card_hoveredAsset === void 0 ? void 0 : _card_hoveredAsset.video) && {
                video: hoverable_cards_grid_component_object_spread_props(hoverable_cards_grid_component_object_spread({}, card.hoveredAsset.video), {
                    videoPlayerRef: (0,react.useRef)(null)
                })
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHoverableCardsGridComponent, {
        className: "hoverable-cards-grid-component",
        style: {
            "--card-count": (cards === null || cards === void 0 ? void 0 : cards.length) || 3
        },
        children: cardsWithVideoPlayerRef === null || cardsWithVideoPlayerRef === void 0 ? void 0 : cardsWithVideoPlayerRef.map(function(card, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hoverable_card, hoverable_cards_grid_component_object_spread({
                textResizeConfig: textResizeConfig,
                fullParagraphAdvancedConfig: fullParagraphAdvancedConfig,
                defaultColor: defaultColor,
                isSelected: index === selectedCardIndex,
                onHover: function() {
                    return onCardHover(index);
                }
            }, card), index);
        })
    });
};
/* harmony default export */ var hoverable_cards_grid_component = (HoverableCardsGridComponent);


/***/ })

}]);